import { centerOfMass } from '@turf/turf'
import { RefObject, useEffect } from 'react'
import { MapRef } from 'react-map-gl'
import { GeckoUnit } from 'types'

export function useHandleCameraFlight(
  unitIDFlyingTo: string | undefined,
  setUnitIDFlyingTo: (uid: string | undefined) => void,
  allUnitsAtSite: ReadonlyArray<GeckoUnit>,
  mapRef: RefObject<MapRef | null>
) {
  useEffect(() => {
    if (!unitIDFlyingTo || !mapRef.current) {
      return
    }

    const unit = allUnitsAtSite.find((u) => u.id === unitIDFlyingTo)
    if (!unit) {
      throw new Error(
        `Tried to fly to unit ${unitIDFlyingTo}, but it was not found in the site`
      )
    }

    const geography = unit.data.geography
    if (!geography) {
      return
    }

    const unitCOM = centerOfMass(geography)
    const [lng, lat] = unitCOM.geometry.coordinates

    mapRef.current.flyTo({
      center: [lng, lat],
      zoom: 18,
    })

    setUnitIDFlyingTo(undefined)
  }, [allUnitsAtSite, mapRef, setUnitIDFlyingTo, unitIDFlyingTo])
}
